import { AddressType } from "@/services/addresses/addressTypes";
import { UserId_Schema } from "@/services/user/userSchema";
import { z } from "zod";

export const AddressId_Schema = z.number().int().positive();

export const Address_Schema = z
  .object({
    id: AddressId_Schema,
    externalIdentification: z.string().nullable(),

    email: z.email().nullable().or(z.literal("")),
    phone: z.string().nullable().or(z.literal("")),

    name: z.string(),
    street: z.string(),
    streetNumber: z.string().nullable(),
    city: z.string(),
    postCode: z.string(),
    country: z.string(),

    type: z.string(), // unused
    userId: UserId_Schema, // unused
  })
  .strict()
  .transform(({ postCode, email, phone, ...rest }) => ({
    email: email === "" ? null : email,
    phone: phone === "" ? null : phone,
    postcode: postCode,
    ...rest,
  }));

export const AddressType_Schema = z.enum(AddressType);
